export const config = {
  apiUrl: 'http://localhost:8080'
};
